module.exports = __webpack_public_path__ + "static/media/sort-size-up-alt.519814f6.svg";